import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'
import { Link, withRouter, Redirect } from 'react-router-dom'
import Moment from 'react-moment'

// Components
import ContentButton from 'app/views/components/ContentButton'
import ContentIcon from 'app/views/components/ContentIcon'
import ModalContentIcon from 'app/views/components/Modals/ModalContentIcon'
import SkeletonLoader from 'app/views/components/Loader/SkeletonLoader'
import Tabs from 'app/views/components/Tabs'

// Redux
import { getPlan } from 'app/state/modules/content'
import { getProfile } from 'app/state/modules/hacker'

// Utils
import analytics from 'app/views/utils/analytics'
import getLocalDateFromUTC from 'app/views/utils/getLocalDateFromUTC'


const propTypes = {
  getPlan: PropTypes.func.isRequired,
}


class MyPlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expandedPhases: [],
      organizationPlanToRender: null,
    }
  }

  componentDidMount() {
    this.props.getPlan()
    this.props.getProfile()
    analytics.page('my-plan')
  }

  renderMenu(phases) {
    Object.size = (obj) => {
      let count = 0
      let key
      for (key in obj) { // eslint-disable-line
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          count += obj[key].length
        }
      }
      return count
    }
    const numberOfActivePhases = phases.filter((x) => x.active).length

    return (
      <div data-uk-sticky="offset: 150" className="hackedu-content-menu">

        <ul className="plans">
          {phases.map((phase) => {
            const now = new Date()
            const today = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
            const startDate = Date.parse(phase.start_date)
            const isFuture = (today < startDate)

            let className = 'past'
            let datePrefix = 'Ended on '
            let date = phase.end_date

            if (phase.active) {
              className = 'active'
              datePrefix = 'Started on '
              date = phase.start_date
            } else if (isFuture) {
              className = 'future'
              datePrefix = 'Starts on '
              date = phase.start_date
            }

            const collapsed = !(phase.active || this.state.expandedPhases.includes(phase.uuid))
            if (collapsed) {
              className = `${className} collapsed`
            }

            return (
              <li className={className} key={phase.uuid}>
                <a // eslint-disable-line
                  onClick={() => {
                    let { expandedPhases } = this.state
                    if (expandedPhases.includes(phase.uuid)) {
                      expandedPhases = expandedPhases.filter((item) => item !== phase.uuid)
                    } else {
                      expandedPhases.push(phase.uuid)
                    }
                    this.setState({ expandedPhases })
                  }}
                >
                  {phase.title}
                </a>
                {(!collapsed) && (
                  <div>
                    <div className="date">
                      {datePrefix}<strong><Moment format="MMMM D, YYYY">{(date) ? date : phase.hacker_plan_start_date}</Moment></strong>
                    </div>
                    <div>
                      <ul className="content">
                        {phase.content.map((content) => {
                          let contentClassName = content.completed_at ? 'complete' : 'incomplete'
                          // TODO: If must_pass_coding_exercise = true, has_test = true, and passed_at is null -- make incomplete
                          return (
                            <li className={contentClassName} key={content.uuid}>
                              <Link to={`/topic/${content.uuid}`}>{content.title}</Link>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                )}

              </li>
            )
          })}
        </ul>
        {(phases.length > numberOfActivePhases) && (
          <ul className="links">
            <li>
              {(this.state.expandedPhases.length > 0) ? (
                <a onClick={() => { this.setState({ expandedPhases: [] }) }}>Collapse Inactive</a>
              ) : (
                <a onClick={() => {
                  let allPhases = []
                  phases.map(phase => {
                    allPhases.push(phase.uuid)
                  })
                  this.setState({ expandedPhases: allPhases })
                }}
                >
                  Expand All
                </a>
              )}

            </li>
          </ul>
        )}

      </div>
    )
  }

  renderPhases(phases) {
    const numberOfActivePhases = phases.filter((x) => x.active).length
    let hasSeenActive = false
    let hasSetNextPhase = false

    return (
      <div className="uk-width-expand uk-section-small">

        {(numberOfActivePhases === 0) && (
          <div className="uk-section uk-text-center">
            You do not have any assigned training.
          </div>
        )}

      {phases.map((phase, phaseIndex) => {
        const now = new Date()
        const today = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
        const startDate = Date.parse(phase.start_date)
        const isFuture = (today < startDate)

        if (phase.active) {
          hasSeenActive = true

          return (
            <div key={phase.uuid}>
              <h1>{phase.title}</h1>
              <p className="uk-text-lead">
                {phase.description}
              </p>
              {(phase.end_date) && (
                <div>
                  Complete by <strong><Moment format="MMMM D, YYYY">{phase.end_date}</Moment></strong>
                </div>
              )}


              <div className="uk-section-small">
                {(phase.content.map((content, contentIndex) => {
                  const hasCompletedContent = !!(content.completed_at)
                  const hasPassedContent = !!(content.passed_at)
                  const hasTest = content.has_test
                  const isActiveForUser = content.is_active_for_user
                  const lessonInProgress = (content.max_progress > 0)

                  let { title } = content
                  if (content.lesson.uuid && content.lesson.title !== content.title) {
                    title = `${content.lesson.title} - ${content.title}`
                  }

                  const localLastCompletedTime = (content.has_test && content.passed_at) ? (
                    getLocalDateFromUTC(content.passed_at)
                  ) : (
                    getLocalDateFromUTC(content.completed_at)
                  )

                  return (
                    <div key={content.uuid}>
                      <div className="uk-panel" key={content.uuid}>
                        <div className="uk-inline">
                          <ContentIcon
                            hasCompletedContent={hasCompletedContent}
                            hasPassedContent={hasPassedContent}
                            hasTest={hasTest}
                            isActiveForUser={isActiveForUser}
                            lessonInProgress={lessonInProgress}
                            license={this.props.license}
                            mustPassCodingExercise={content.must_pass_coding_exercise}
                            requiresSubscription={content.requires_subscription}
                          />
                          <h3 className="uk-inline">
                            <a href={`/topic/${content.uuid}`} className="uk-link-reset">
                              {title}
                            </a>
                          </h3>
                        </div>
                        <div data-uk-grid="">
                          <div className="uk-width-4-5">
                            <p>
                              {content.description}
                            </p>
                            {(hasCompletedContent) && (
                              <div className="uk-text-small uk-text-italic">
                                Last completed on <Moment format="MMMM D, YYYY">{localLastCompletedTime}</Moment>
                              </div>
                            )}
                          </div>
                          <div className="uk-width-1-5 uk-text-right">
                            <ContentButton
                              hasCompletedContent={hasCompletedContent}
                              isActiveForUser={isActiveForUser}
                              lessonInProgress={lessonInProgress}
                              requiresSubscription={content.requires_subscription}
                              url={`/topic/${content.uuid}`}
                            />
                          </div>
                        </div>
                      </div>

                      {(contentIndex !== phase.content.length - 1) && (
                        <hr />
                      )}

                    </div>
                  )
                }))}
              </div>

              {(phases.length - 1 > phaseIndex && phases[phaseIndex + 1].start_date) && (
                <div className="uk-section uk-section-muted uk-padding uk-margin-large-top uk-text-center">
                  Next training phase starts on <strong><Moment format="MMMM D, YYYY">{phases[phaseIndex+1].start_date}</Moment></strong>
                </div>
              )}

            </div>
          )
        }

        if (hasSeenActive === false && isFuture === true && hasSetNextPhase === false) {
          hasSetNextPhase = true
          return (
            <div className="uk-section uk-section-muted uk-padding uk-margin-large-top uk-text-center" key={phase.uuid}>
              Next training phase starts on <strong><Moment format="MMMM D, YYYY">{phase.start_date}</Moment></strong>
            </div>
          )
        }
      })}
      </div>
    )
  }

  renderDefaultPlan() {
    return (
      <>
        <div className="uk-padding uk-padding-remove-top uk-padding-remove-bottom">
          <div className="uk-text-center uk-padding">
            <h2>{this.props.plan.default.title}</h2>
            <div className="uk-text-meta">
              {this.props.plan.default.description}
            </div>
          </div>
          {this.renderPhases(this.props.plan.default[0].groups || [])}
        </div>
      </>
    )
  }

  renderOrganizationPlan() {
    if (!this.state.organizationPlanToRender) {
      return null
    }
    const phases = this.state.organizationPlanToRender.groups

    return (
      <div data-uk-grid="">
        <div className="uk-width-large">
          <div>
            {this.renderMenu(phases)}
          </div>
        </div>
        <div className="uk-width-expand">
          {this.renderPhases(phases)}
        </div>
      </div>
    )
  }

  renderPlansByOrganization() {
    const { plan, organizationsHash } = this.props
    const tabs = Object.keys(plan).reduce((arr, organizationUUID) => {
      plan[organizationUUID].forEach((teamPlan) => {
        arr.push({
          key: `${organizationUUID}-${teamPlan.team_uuid || 'no-team'}`,
          title: teamPlan.team_name ? (
            <>
              {organizationsHash[organizationUUID].name}
              <br />
              {teamPlan.team_name}
              &nbsp;Plan
            </>
          )
            : (
              <div style={{
                display: 'table-cell',
                verticalAlign: 'bottom',
              }}
              >
                {`${organizationsHash[organizationUUID].name} Plan`}
              </div>
            ),
          plan: teamPlan,
        })
      })
      return arr
    }, []).map((organizationData) => ({
      ...organizationData,
      onChangeTab: () => {
        this.setState({
          organizationPlanToRender: organizationData.plan,
        })
      },
    }))
    return (
      <>
        <Tabs
          hide={tabs.length === 1}
          ref={(ref) => { this.tabsComponent = ref }}
          tabs={tabs}
        />
        {this.renderOrganizationPlan()}
      </>
    )
  }

  renderPlans(isNotInAnyOrganization) {
    if (isNotInAnyOrganization) return this.renderDefaultPlan()
    return this.renderPlansByOrganization()
  }

  render() {
    const isNotInAnyOrganization = Boolean(this.props.plan.default)
    if (isNotInAnyOrganization) {
      return <Redirect to="/all" />
    }

    return (
      <div className="uk-hackedu-container-main">
        <div className="uk-container">
            {(
              this.props.loadingPlan === false
              && JSON.stringify(this.props.plan) !== '{}'
              && (
                JSON.stringify(this.props.organizationsHash) !== '{}'
                || this.props.plan.default
              )) ? (
                this.renderPlans(isNotInAnyOrganization)
              ) : (
                <SkeletonLoader visible />
              )}
        </div>

        <ModalContentIcon />
      </div>
    )
  }
}

MyPlan.propTypes = propTypes

const mapStateToProps = (state) => ({
  // auth
  email: state.auth.user.email,

  // content
  plan: state.content.plan,
  loadingPlan: state.content.loadingPlan,

  // hacker
  license: state.hacker.license,
  mustPassCodingExercise: state.hacker.mustPassCodingExercise,
  organizationsHash: state.hacker.organizationsHash,
})
const mapDispatchToProps = (dispatch) => ({
  getPlan: () => { dispatch(getPlan()) },
  getProfile: () => { dispatch(getProfile()) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyPlan))
